<sdk-conversation-group-nav
  [conversationFilter]="openConversationFilter"
  [groupFn]="groupFn"
  [groupNameFn]="groupNameFn"
  [groupSubtitleFn]="groupSubtitleFn"
  [types]="[ConversationTypes.JobApplicationDM]"
  [emptyStateSubtitle]="'This is where you direct message candidates'"
  [darkMode]="true"
></sdk-conversation-group-nav>
